export default function InputCompanyCity() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            user: "=",
            validation: "=",
            label: "="
        },
        template: require("./input-company-city.html")

        // link: function(scope, element, attrs){},
        // controller: function ( $scope) {

        // }
    };
}
